module.exports = __webpack_public_path__ + "media/images/athletes/1763-035b485c11ec7d8776b2dc5eeacc4e2f.png";